import { ENTITY_TYPE_ALBUM } from '../constants';

export function normalizeSimilarAlbums({ results }) {
  const albums = results;
  return albums.map(album => ({
    content: {
      id: album.id,
      slug: album.slug,
      type: ENTITY_TYPE_ALBUM,
    },
    ...album,
  }));
}
